export default __webpack_public_path__ + "static/media/cancer_banner_En.27dece43.webp";